import { render, staticRenderFns } from "./hex-color.component.vue?vue&type=template&id=51576706&scoped=true&"
import script from "./hex-color.component.vue?vue&type=script&lang=ts&"
export * from "./hex-color.component.vue?vue&type=script&lang=ts&"
import style0 from "./hex-color.component.vue?vue&type=style&index=0&id=51576706&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51576706",
  null
  
)

export default component.exports